import React from 'react';
import Input from './Input';
import FormInput from './FormInput';
import DropDown from './DropDown';
import TextArea from './TextArea';
import RadioButton from './RadioButton';

const FormikControl = (props) => {
	const { control, ...rest } = props;
	switch (control) {
		case 'input':
			return <Input {...rest} />;
		case 'forminput':
			return <FormInput {...rest} />;
		case 'dropdown':
			return <DropDown {...rest} />;
		case 'textarea':
			return <TextArea {...rest} />;
		case 'radio':
			return <RadioButton {...rest} />;
		default:
			return null;
	}
};

export default FormikControl;
